function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.997 6.196H3.335a.333.333 0 0 0-.333.334v4.635c0 .184.15.333.333.333.781 0 3.322.711 4.236.985a.32.32 0 0 0 .191 0c.915-.273 3.458-.985 4.235-.985a.333.333 0 0 0 .333-.333V6.53a.333.333 0 0 0-.333-.334z",
  fill: "#656D78"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M3.335 11.498c.09 0 .203.01.333.026V6.196h-.333a.333.333 0 0 0-.333.334v4.635c0 .184.15.333.333.333z",
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.088 5.513l-7.334-2a.334.334 0 0 0-.175 0l-7.333 2a.333.333 0 0 0 0 .642l7.333 2a.334.334 0 0 0 .175 0l7.334-2a.333.333 0 0 0 0-.642z",
  fill: "#434A54"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 7.833a.333.333 0 0 1-.332-.333V5.834a.333.333 0 1 1 .666 0V7.5a.333.333 0 0 1-.333.333z",
  fill: "#F6BB42"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.943 8.315l-.666-1a.334.334 0 0 0-.555 0l-.666 1a.331.331 0 0 0-.056.184v1.666c0 .184.149.334.333.334h1.333c.184 0 .333-.15.333-.334V8.5c0-.066-.02-.13-.056-.185z",
  fill: "#FFCE54"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 6.167H7.337a.333.333 0 0 1 0-.666H15a.333.333 0 1 1 0 .666z",
  fill: "#F6BB42"
});

var Svg8BaseAcademy = function Svg8BaseAcademy(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default __webpack_public_path__ + "static/media/8base-academy.c43f3815.svg";
export { Svg8BaseAcademy as ReactComponent };